var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"anni-logo",attrs:{"alt":"anni.care Logo","src":"https://anni.care/images/commons/anni.careBrandLogo.svg","loading":"eager","fetchpriority":"high","width":"165","height":"27"}})
}
var staticRenderFns = []

export { render, staticRenderFns }